import { useLocation } from "react-router-dom";
import { StoreRefundList, SuperRefundList } from "../components";

export const RefundList = () => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  return isStoreAdmin ? <StoreRefundList /> : <SuperRefundList />;
};
